import { render, staticRenderFns } from "./rankCarousel.vue?vue&type=template&id=25d694ce&scoped=true&"
import script from "./rankCarousel.vue?vue&type=script&lang=js&"
export * from "./rankCarousel.vue?vue&type=script&lang=js&"
import style0 from "./rankCarousel.vue?vue&type=style&index=0&id=25d694ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d694ce",
  null
  
)

export default component.exports